import { createAction, props } from '@ngrx/store';

export const initMap = createAction('[Map/Page] Init Map', props<{ mapId: string; resetBasemap: boolean }>());

export const fetchPhotos = createAction('[Map/Page] Fetch Photos', props<{ mapId: string }>());

export const leaveMap = createAction('[Map/Page] Leave Map');
